<template>
  <div class="container">

    <div class="container">
      <div class="row">
        <div class="col-sm-4">
          <h3>Shop</h3>
          <p>We hebben eerder een webshop actief gehad, maar juist voor de jeugdwerk is eigenlijk alles maatwerk.</p>
          <p>Daarom hebben we ervoor gekozen geen webshop meer actief te hebben, maar dat betekent niet dat we geen 
          jeugd-specifieke artikelen meer kunnen leveren.</p>
          <p>Neem contact met mij op via info@fietsenmetvictor.nl of +31 85 30 11 500 als je op zoek bent naar een 
            bepaald onderdeel of een oplossing. </p>
        </div>
        <div class="col-sm-8">
        <h3>Assortiment</h3>
        <ul class="list-group">
        <li class="list-group-item" v-for="item in assortiment">
          {{item.naam}}
        </li>
        </ul>
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'verzetten',
  created: function () {
  },
  data () {
    return {
      assortiment: [
        {naam: 'Cassettes en kettingbladen'},
        {naam: 'Crankstellen en pedalen'},
        {naam: 'Kettingbladen'},
        {naam: 'Groepsets en onderdelen'},
        {naam: 'Remmen'},
        {naam: 'Wielen'},
        {naam: 'Sturen, stuurpennen, zadelpennen'},
        {naam: 'Banden'}
      ]
    }
  },
  methods: {

  },
  watch: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// Shop.vue?031df6c4